import React from 'react'
import CareerDetails from '../CareerDetails'
import jobList from './positionList.json'

const QASpecialist = () => {
  return <CareerDetails {...jobList[6]} />
}

export default QASpecialist
